import styled from "styled-components"

export const StyledFakeSearchContainer = styled.div`
  display: flex;
  align-items: center;
  height: 80px;

  @media(min-width: 768px) {
    display: none;
  }
`

export const StyledFakeSearch = styled.div`
  display: flex;
  align-items: center;
  padding-left: 20px;
  background-color: ${({theme}) => theme.colors.greys.light};
  margin: 0 20px;
  width: 100%;
  height: 50px;
  border-radius: 12px;
`

export const StyledFakeSearchText = styled.div`
  margin-left: 15px;
  font-size: 18px;
  color: ${({theme}) => theme.colors.greys.mediumDark};
`
